<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G H Raisoni Pune District Selection Chess Championship 2026</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G H Raisoni Pune District Selection Chess Championship 2026 Successfully Concludes</span></h2>
        </div>

        <p><strong>Date: </strong>18th & 20th June 2026</p>
        <p><strong>Venue: </strong>Ashwamedh Hall, Karve Road, Pune</p>
        <p><strong>Organized in Association with: </strong>Pune District Chess Circle (PDCC)</p>
        <p>The G H Raisoni Pune District Selection Chess Championship 2026 was successfully held on 18th & 20th June
            2026 at Ashwamedh Hall, Karve Road, Pune, in association with the Pune District Chess Circle (PDCC). The
            championship served as the official selection event for the Maharashtra State Chess Championships 2026,
            bringing together 167 players across the Open, Under-17 Open, and Under-17 Girls categories.</p>

        <h5 class="primary-purple">Championship Winners</h5>
        <div class="row mb-4">
            <div class="col">
                <p><strong>Open Category</strong></p>
                <ul class="list-style list-style1">
                    <li>Joshi Aditya Shripad</li>
                    <li>Salunke Siddhant</li>
                    <li>Om Nagnath Lamkane</li>
                </ul>
            </div>
            <div class="col">
                <p><strong>Under-17 Open</strong></p>
                <ul class="list-style list-style1">
                    <li>Bhuvan Suhas Shitole</li>
                    <li>AIM Alaukik Sinha</li>
                    <li>Patil Akshaj</li>
                </ul>
            </div>
            <div class="col">
                <p><strong>Under-17 Girls</strong></p>
                <ul class="list-style list-style1">
                    <li>WCM Nihira Koul</li>
                    <li>Sai Vijaysinh Patil</li>
                    <li>Katariya Mehek</li>
                </ul>
            </div>
        </div>

        <p>A total of 14 players qualified to represent Pune District at the Maharashtra State Chess Championships
            2026, marking a significant achievement for the district's emerging chess talent.</p>

        <h5 class="primary-purple">Prize Distribution Ceremony</h5>
        <p>The championship concluded with a grand Prize Distribution Ceremony, graced by Shiv Chhatrapati Awardee
            Shri Jayant Gokhale as the Chief Guest. Winners and top performers were felicitated with trophies,
            medals, certificates, and prizes in recognition of their outstanding achievements, dedication, and
            exemplary sportsmanship.</p>
        <p>G H Raisoni congratulates all the winners, participants, coaches, parents, arbiters, volunteers, and
            supporters for making the championship a grand success and reaffirming its commitment to promoting
            excellence in chess and nurturing young sporting talent.</p>

        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-pune-district-selection-chess.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
